/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
*/

/**
 * Revert blob types to original type
 * @param {Object} data - data to be reverted
 * @param {String} type - type of the blob
 * @param {Object} customHeaders - custom headers to be added
 * @returns {Object} - returns the blob and headers
 */
export const revertBlobTypes = (data, customHeaders = {}) => {
  let blob;
  const mimeType = data.headers['content-type'];

  if (mimeType === 'application/pdf') {
    const byteCharacters = atob(data.blob.split('base64,')[1]);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512);
      const byteNumbers = new Array(slice.length);

      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    blob = new Blob(byteArrays, { type: mimeType });
  } else if (mimeType === 'application/zip' || mimeType === 'application/octet-stream') {
    // Handle ZIP or binary data
    blob = new Blob([data.blob], { type: mimeType });
  } else {
    // Handle other types
    blob = new Blob([data.blob], { type: mimeType });
  }

  return {
    blob,
    headers: {
      ...data.headers,
      ...customHeaders
    }
  };
};
